import { ScheduleTreatment, ScheduleTreatmentPeriod } from '../../../../entities/ScheduleTreatment';

export default class ScheduleTreatmentTableModel {
  static getPeriod(period: ScheduleTreatmentPeriod): string {
    const periods = {
      [ScheduleTreatmentPeriod.MORNING]: 'Manhã',
      [ScheduleTreatmentPeriod.AFTERNOON]: 'Tarde',
      [ScheduleTreatmentPeriod.NIGHT]: 'Noite'
    };
    return periods[period] || 'Manhã';
  }

  static hasTreatments(scheduleTreatment: ScheduleTreatment | null): boolean {
    return scheduleTreatment ? scheduleTreatment.treatments.length > 0 : false;
  }
}
